<template>
    <portal to="notifications">
        <transition name="notification" appear>
            <div
                v-if="show" 
                class="notification" 
                @mouseenter="stopTimeout" 
                @mouseleave="startTimeout">
                <span :class="{'success': type == 'success'}" class="notification-bar" />
                <div class="notification-group">
                    <div class="notification-title">
                        <h4>{{ title }}</h4>
                    </div>
                    <div class="notification-content">
                        <p>{{ message }}</p>
                    </div>
                    <span class="notification-close" @click="show = false"><i class="icon icon-close" /></span>
                </div>
            </div>
        </transition>
    </portal>
</template>

<script>
export default {
    name: 'notification',
    data() {
        return {
            show: true,
            notificationTimeout: null
        }
    },
    mounted() {
        this.startTimeout()
    },
    methods: {
        startTimeout() {
            this.notificationTimeout = 
                setTimeout( ()=>{
                    this.show = false
                }, 5000)
        },
        stopTimeout() {
            clearTimeout(this.notificationTimeout)
        }
    },
}
</script>

<style lang="stylus">
    @import '../../../stylus/variables'
    
    

    .notification
        width: 330px
        display: block
        margin: 10px 0
        border: 1px solid #ebeef5
        border-radius: 8px
        position: relative
        background-color: #fff
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    .notification-bar
            height: 100%;
            display: block;
            width: 5px;
            border-radius: 8px 0 0 8px
            position: absolute
            &.success
                background-color: $green
    .notification-group
        margin: 10px 20px
        position: relative
    .notification-title
        h4
            margin: 0 0 5px 0
    .notification-content
        p
            margin: 6px 0 0
            font-size: 14px
            line-height: 21px
            color: #606266
    .notification-close
        position: absolute
        top: 0px
        right: -10px
        cursor: pointer
        color: #909399

    .notification-enter-active,
    .notification-leave-active
        transition: all .3s
    .notification-enter-to
        right: 0px
    .notification-enter
        right: -350px
    .notification-leave-to
        opacity: 0 !important
</style>
